if($('.type-detail').length){
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart'))
   
}